import ApiFetcher2 from '../../../modules/apis/ApiFetcher2';

class StudentActivityNotificationApi {
  static getByAssignmentId(assignmentId, params) {
    return ApiFetcher2.get(`student-activity/${assignmentId}/`, {params});
  }
}

export default StudentActivityNotificationApi;
